import { atom } from 'recoil';
import { Constants } from '@/utils/constants';
import persistAtom from './recoilPersist';

/** パスワード再設定フローで入力する本人確認情報。 */
type PasswordResetForm = {
  lsName: string;
  flName: string;
  birthDateYear: string;
  birthDateMonth: string;
  birthDateDay: string;
  authenticationMethod: string;
  mailAddress: string;
  phoneNumber: string;
  ispNumber: string;
  simNumber: string;
};
export type { PasswordResetForm };

/**
 * パスワード再設定画面の入力内容を保持する state。
 * OTP 発行、本人確認、戻る操作でも入力内容を失わないようにセッションへ保持する。
 */
const PasswordResetFormState = atom<PasswordResetForm>({
  key: 'passwordResetForm',
  default: {
    lsName: '',
    flName: '',
    birthDateYear: '',
    birthDateMonth: '',
    birthDateDay: '',
    authenticationMethod: Constants.PasswordReset.AuthenticationMethod.MAIL,
    mailAddress: '',
    phoneNumber: '',
    ispNumber: '',
    simNumber: '',
  },
  effects_UNSTABLE: [persistAtom],
});
export { PasswordResetFormState };
